// Dummy data for the SolarDistributionPage.
// Contains months and percentage distribution of annual solar yield.

export const MONTHS = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
export const DISTRIBUTION = [3, 4, 6, 8, 11, 12, 12, 11, 9, 7, 5, 2];

export default {
  MONTHS,
  DISTRIBUTION,
};